<template>
  <v-btn
    color="error"
    large
    :to="$_getRouteDeleteHard(role,model.key,$route.params.id,me)"
  >
  Delete Permanently
  </v-btn>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      'me',
      'role',
      'model',
    ],
    data: () => ({
      //
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>